import React from 'react'
import data from './data.json'
import { Intro, Layout, Header, SectionTitle } from '../../../../components'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            People trust predictable content. Keeping word use, spelling,
            capitalization and abbreviations consistent helps build a common
            language.
          </p>

          <p>
            All proper nouns, including M{'&'}T product names, will always be
            capitalized. Features and products that aren't unique to M{'&'}T
            Bank are not capitalized unless otherwise noted here.
          </p>
        </Intro>
        <SectionTitle className="new-section-title">Aa</SectionTitle>
        <h3 class="c-title-3--light">account</h3>
        <p className="paragraph-xsmall">
          Lowercase, unless the word is part of a formal product name
        </p>
        <SectionTitle className="new-section-title">Bb</SectionTitle>
        <h3 class="c-title-3--light">bank</h3>
        <p className="paragraph-xsmall">
          Lowercase, unless preceded by M{'&'}T
        </p>
        <h3 class="c-title-3--light">branch</h3>
        <p className="paragraph-xsmall">Always use branch, not office</p>

        <SectionTitle className="new-section-title">Cc</SectionTitle>
        <h3 class="c-title-3--light">creditworthiness</h3>
        <p className="paragraph-xsmall">One word</p>

        <SectionTitle className="new-section-title">Ee</SectionTitle>
        <h3 class="c-title-3--light">email</h3>
        <p className="paragraph-xsmall">email is not hyphenated</p>

        <SectionTitle className="new-section-title">Hh</SectionTitle>
        <h3 class="c-title-3--light">homebuyer</h3>
        <p className="paragraph-xsmall">One word</p>
        <h3 class="c-title-3--light">homeowner</h3>
        <p className="paragraph-xsmall">One word</p>
        <h3 class="c-title-3--light">homeownership</h3>
        <p className="paragraph-xsmall">One word</p>

        <SectionTitle className="new-section-title">Ii</SectionTitle>
        <h3 class="c-title-3--light">internet</h3>
        <p className="paragraph-xsmall">Lowercase</p>

        <SectionTitle className="new-section-title">Ll</SectionTitle>
        <h3 class="c-title-3--light">log in/log out</h3>
        <p className="paragraph-xsmall">Two words when used as an action</p>
        <h3 class="c-title-3--light">login/logout</h3>
        <p className="paragraph-xsmall">
          One word when used as a noun or an adjective
        </p>

        <SectionTitle className="new-section-title">Mm</SectionTitle>
        <h3 class="c-title-3--light">mtb.com</h3>
        <p className="paragraph-xsmall">
          Do not use "www." when writing out our url
        </p>

        <SectionTitle className="new-section-title">Oo</SectionTitle>
        <h3 class="c-title-3--light">online</h3>
        <p className="paragraph-xsmall">One word, not hyphenated</p>
        <h3 class="c-title-3--light">Online Banking</h3>
        <p className="paragraph-xsmall">
          Capitalize both words when referring to the platform
        </p>

        <SectionTitle className="new-section-title">Pp</SectionTitle>
        <h3 class="c-title-3--light">passcode</h3>
        <p className="paragraph-xsmall">Correct usage for login screens</p>
        <h3 class="c-title-3--light">Prime Rate</h3>
        <p className="paragraph-xsmall">Capitalize both words</p>

        <SectionTitle className="new-section-title">Uu</SectionTitle>
        <h3 class="c-title-3--light">User ID</h3>
        <p className="paragraph-xsmall">Correct use for login screens</p>

        <SectionTitle className="new-section-title">Ww</SectionTitle>
        <h3 class="c-title-3--light">website</h3>
        <p className="paragraph-xsmall">One word, lowercase</p>

        <hr />
        <SectionTitle>Abbreviations</SectionTitle>
        <p>
          Only use the abbreviations below when UI space is limited. Otherwise
          always write out the full word.
        </p>

        <div class="l-margin-top--xxlarge l-flex-col--xs-8">
          <table>
            <thead>
              <th>Days</th>
              <th>Abbreviation</th>
            </thead>
            <tbody>
              <tr>
                <td>Monday</td>
                <td>Mon</td>
              </tr>
              <tr>
                <td>Tuesday</td>
                <td>Tue</td>
              </tr>
              <tr>
                <td>Wednesday</td>
                <td>Wed</td>
              </tr>
              <tr>
                <td>Thursday</td>
                <td>Thu</td>
              </tr>
              <tr>
                <td>Friday</td>
                <td>Fri</td>
              </tr>
              <tr>
                <td>Saturday</td>
                <td>Sat</td>
              </tr>
              <tr>
                <td>Sunday</td>
                <td>Sun</td>
              </tr>
            </tbody>
          </table>

          <table className="l-margin-top--xxlarge">
            <thead>
              <th>Months</th>
              <th>Abbreviation</th>
            </thead>
            <tbody>
              <tr>
                <td>January</td>
                <td>Jan</td>
              </tr>
              <tr>
                <td>February</td>
                <td>Feb</td>
              </tr>
              <tr>
                <td>March</td>
                <td>Mar</td>
              </tr>
              <tr>
                <td>April</td>
                <td>Apr</td>
              </tr>
              <tr>
                <td>May</td>
                <td>May</td>
              </tr>
              <tr>
                <td>June</td>
                <td>Jun</td>
              </tr>
              <tr>
                <td>July</td>
                <td>Jul</td>
              </tr>
              <tr>
                <td>August</td>
                <td>Aug</td>
              </tr>
              <tr>
                <td>September</td>
                <td>Sep</td>
              </tr>
              <tr>
                <td>October</td>
                <td>Oct</td>
              </tr>
              <tr>
                <td>November</td>
                <td>Nov</td>
              </tr>
              <tr>
                <td>December</td>
                <td>Dec</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Layout>
    </>
  )
}
